import { UseCase } from "../../useCase"
import { Survey } from "../../../entities/Survey"
import { SurveyRepository } from "../../../repositories/surveyRepository"

export class UpdateSurveyUseCase implements UseCase<Survey, Survey> {
	private _repository
	constructor({ SurveyRepository }: { SurveyRepository: SurveyRepository }) {
		this._repository = SurveyRepository
	}

	exec(survey: Survey) {
		return this._repository.updateSurvey(survey)
	}
}
